import { createSlice } from '@reduxjs/toolkit';
import { getHRVacanciesListThunk } from './HRVacancies.thunk';
import { HRControlState } from './HRVacancies.type';
import { RootState } from '../../store';

const SLICE_NAME = 'hrVacancies';

const initialState: HRControlState = {
  items: [],
  isLoading: false,
  pagination: undefined,
};

export const hrVacanciesSlice = createSlice<HRControlState, any>({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getHRVacanciesListThunk.pending, state => {
      state.isLoading = true;
    });
    builder.addCase(getHRVacanciesListThunk.fulfilled, (state, { payload }) => {
      const { data, pagination } = payload;
      state.isLoading = false;
      state.items = data;
      state.pagination = {
        currentPage: pagination.current_page,
        lastPage: pagination.last_page,
        perPage: pagination.per_page,
        from: pagination.from,
        to: pagination.to,
        total: pagination.total,
      };
    });
    builder.addCase(getHRVacanciesListThunk.rejected, state => {
      state.isLoading = false;
    });
  },
});

export const getHRVacanciesList = (state: RootState) => state.hrVacancies.items;
export const getHRVacanciesLoading = (state: RootState) =>
  state.hrVacancies.isLoading;

export default hrVacanciesSlice.reducer;
